"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typeOfOrderOptions = void 0;
exports.typeOfOrderOptions = {
    quickStrike: 'QS',
    authorizedFutures: 'AF',
    alwaysAvailable: 'AA',
    nikeByYou: 'NBY',
};
